<div class="faq" (clickOutside)="closeAllFaq()">
  <div *ngIf="categoryId != -1" class="faq__title">FAQ</div> <!-- -1 is hide faq title used for product details-->
  <ng-container *ngFor="let faq of additionalFAQS">
    <div *ngIf="faq.question && faq.answer" (click)="faq.dontShow = !!!faq.dontShow">
      <div class="arrow-border">
        {{ faq.question }}
      </div>
      <div class="answer-block" [innerHTML]="faq.answer" *ngIf="faq.dontShow"></div>
    </div>


  </ng-container>
  <ng-container *ngIf="catFaqExist">
    <div *ngIf="faqInfos.questionOne && faqInfos.answerOne" (click)="showFAQ(0)">
      <div class="arrow-border">
        {{ faqInfos.questionOne }}
      </div>
      <div class="answer-block" [innerHTML]="faqInfos.answerOne" *ngIf="visibleFAQ[0]"></div>
    </div>

    <div *ngIf="faqInfos.questionTwo && faqInfos.answerTwo" (click)="showFAQ(1)">
      <div class="arrow-border">
        {{ faqInfos.questionTwo }}
      </div>
      <div class="answer-block" [innerHTML]="faqInfos.answerTwo" *ngIf="visibleFAQ[1]"></div>
    </div>

    <div *ngIf="faqInfos.questionThree && faqInfos.answerThree" (click)="showFAQ(2)">
      <div class="arrow-border">
        {{ faqInfos.questionThree }}
      </div>
      <div class="answer-block" [innerHTML]="faqInfos.answerThree" *ngIf="visibleFAQ[2]"></div>
    </div>

    <div *ngIf="faqInfos.questionFour && faqInfos.answerFour" (click)="showFAQ(3)">
      <div class="arrow-border">
        {{ faqInfos.questionFour }}
      </div>
      <div class="answer-block" [innerHTML]="faqInfos.answerFour" *ngIf="visibleFAQ[3]"></div>
    </div>

    <div *ngIf="faqInfos.questionFive && faqInfos.answerFive" (click)="showFAQ(4)">
      <div class="arrow-border">
        {{ faqInfos.questionFive }}
      </div>
      <div class="answer-block" [innerHTML]="faqInfos.answerFive" *ngIf="visibleFAQ[4]"></div>
    </div>
  </ng-container>

  <div class="w-100 flex flex-column align-items-center mt-3">
   
    <div *ngFor="let  question of communityQuestionsAndAnswers; index as i" (click)="toggelViewAnswersToCommunityQuestions(i)">
      <div class="arrow-border position-relative">
        <div style="top: 30%; right: 10%; color: var(--white); gap: 0.5em" class="position-absolute d-flex">
          <button class="t-btn" (click)="openAnswerQuestionModal(question)">
            <i class="fa fa-plus"></i>
          </button>
          <button (click)="$event.stopPropagation(); toggleHeartCommunityQuestion(question)" class="t-btn">
            <i [class.fa-solid]="question.isLiked" [class.fa-regular]="!question.isLiked" class="fa-heart"></i> {{question.likeCount}}
          </button>
          <button   *ngIf="isUserAdmin" (click)="removeQuestion(question)" class="t-btn" >
            <i style="font-size: .8em; " class="fa fa-x"></i>
          </button>
         
         </div>
       
       
        {{ question.text }}
      </div>
      <ng-container *ngIf="areAnswerVisisbleCommunityQuestions[i]">
        <div class="answer-block position-relative" *ngFor="let answer of question.answers" >
          <div>{{answer.text}}</div>
          <button (click)="$event.stopPropagation(); toggleHeartCommunityAnswer(answer)" class="t-btn position-absolute" style="top: 50%; right: 0;">
            <i [class.fa-solid]="answer.isLiked" [class.fa-regular]="!answer.isLiked" class="fa-heart"></i> {{answer.likeCount}}
          </button>
         
          <button (click)="$event.stopPropagation(); removeAnswer(answer)" class="t-btn position-absolute" style="top: 0; right: 0;" *ngIf="isUserAdmin">
            <i style="font-size: .8em;color: var(--secondary);" class="fa fa-x"></i> 
          </button>
        </div>
      </ng-container>
      
    </div>
  </div>
 

  <button class="w-100 btn btn-outline-primary" (click)="openAskQuestionsModal()">+</button>
</div>

<ng-template #askQuestionAboutCategory>
  <div class="ask-question p-4">
    <p class="title mb-3">Ask Question </p>
    <div style="width: 80%;">
      <textarea rows="9" placeholder="Write your question about products in this category" [(ngModel)]="askQuestionText" class="form-control"></textarea>

    </div>
   
    <button class="mt-3 btn btn-outline-primary" (click)="addQuestionToCategory()">Add Question</button>
  </div>
</ng-template>

<ng-template #answerQuestion>
  <div class="ask-question p-4">
    <p class="title mb-3">Post answer to questions "{{answeringQuestion?.text}}"</p>
    <div style="width: 80%;">
      <textarea rows="9" placeholder="Write your answer to  the selected question in this category" [(ngModel)]="answerQuestionText" class="form-control"></textarea>

    </div>
   
    <button class="mt-3 btn btn-outline-primary" (click)="addAnswerQuestion()">Answer Question</button>
  </div>
</ng-template>